/** Normalize a padded OTP cell to display/submit value. */
export function normalizeOtpCell(digit: string): string {
  return digit === ' ' ? '' : digit
}

/** Apply one digit edit at `index` across the OTP cell array. */
export function mergeOtpDigitAt(
  digits: string[],
  index: number,
  char: string
): string[] {
  return digits.map((d, i) => {
    if (i === index) return char
    return normalizeOtpCell(d)
  })
}

export function displayOtpCell(digit: string | undefined): string {
  const trimmed = digit?.trim()
  if (trimmed) return trimmed
  return ''
}

export function stripNonDigits(value: string): string {
  return value.split('').filter((c) => c >= '0' && c <= '9').join('')
}

export function stripOtpWhitespace(value: string): string {
  return value.replaceAll(' ', '')
}

/** Digits from clipboard text (strips spaces, dashes, etc.). */
export function otpFromClipboard(text: string, length = 6): string {
  return stripNonDigits(text).slice(0, length)
}
